import Toastify from 'toastify-js';

const commonToastConfig = {
    duration: 7000,
    close: true,
    gravity: "bottom",
    position: "right",
    stopOnFocus: true, // Prevents dismissing of toast on hover
}

export let MessageDisplayerUtility = {
    error: function (message) {
        let errorToast = Toastify({
            text: message,
            className: 'error-message',
            onClick: function () {
                errorToast.hideToast();
            },
            ...commonToastConfig
        })
        errorToast.showToast();
    },

    success: function (message) {
        let successToast = Toastify({
            text: message,
            className: 'success-message',
            onClick: function () {
                successToast.hideToast();
            },
            ...commonToastConfig
        })
        successToast.showToast();
    },
};
